import { TREZOR_AFFILIATE } from "constants/links";

import React, { useState } from "react";

import { Stack, Typography, useTheme, Button, Link, Collapse, useMediaQuery, styled } from "@mui/material";
import trezorSafeBanner from "assets/images/trezor-safe-banner.png";
import { fontWeight } from "config/Theme/options";
import { useUserDataContext } from "context/UserDataContext";
import { Trans, useTranslation } from "react-i18next";
import { SubscriptionType } from "types/enums";

const trezorAffiliateLink = `${TREZOR_AFFILIATE}&source=dashboard`;

const StyledButton = styled(Button)({
  "&.Mui-disabled": {
    backgroundColor: "#202736",
    color: "#959595",
  },
});

const Trezor: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { subscriptionType } = useUserDataContext();
  const [open, setOpen] = useState(false);

  return (
    <Stack spacing={2}>
      <Link href={trezorAffiliateLink} target={"_blank"} sx={{ display: "block", position: "relative", width: "100%" }}>
        <img src={trezorSafeBanner} alt={trezorAffiliateLink} style={{ width: "100%", display: "block" }} />
      </Link>
      <Typography color={"white"} fontSize={{ xs: "0.875rem", md: "1.375rem" }} fontWeight={fontWeight.semiBold}>
        {t("dashboard.communityHub.trezor.title")}
      </Typography>
      <Typography
        color={"white"}
        fontSize={{ xs: "0.75rem", md: "1rem" }}
        fontWeight={fontWeight.light}
        textAlign={"left"}>
        <Trans
          i18nKey="dashboard.communityHub.trezor.description"
          components={{
            a: <Link href={trezorAffiliateLink} target={"_blank"} fontWeight={fontWeight.semiBold} />,
            aTrezorPage: <Link href={"/trezor"} fontWeight={fontWeight.semiBold} />,
          }}
        />
      </Typography>
      {!open && (
        <StyledButton
          variant="contained"
          onClick={() => setOpen(true)}
          size={isMobile ? "small" : "medium"}
          disabled={subscriptionType !== SubscriptionType.PRO}
          fullWidth>
          {t("dashboard.communityHub.trezor.cta")}
        </StyledButton>
      )}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Typography
          fontWeight={fontWeight.regular}
          color={"white"}
          fontSize={{ xs: "1rem", md: "1.375rem" }}
          textAlign={"center"}>
          <Trans
            i18nKey="dashboard.communityHub.trezor.couponText"
            components={{
              a: <Link href={trezorAffiliateLink} target={"_blank"} color={theme.palette.primary.main} />,
            }}
          />
        </Typography>
      </Collapse>
    </Stack>
  );
};

export default Trezor;
